var React = require('react');

function NavBackIcon (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"#AEB5C0","points":"7.59 .733 11.829 4.972 10.83 5.972 10.812 5.953 7.499 9.267 6.5 8.268 9.069 5.698 .5 5.699 .5 4.199 9.057 4.198 6.591 1.732","transform":"rotate(-180 6 5)"}));
}

NavBackIcon.defaultProps = {"width":"12","height":"10","viewBox":"0 0 12 10"};

module.exports = NavBackIcon;

NavBackIcon.default = NavBackIcon;
